 
 $(document).ready(function(){
  var FREE_PRODUCT_ID = 8980387823840; // 🔴 replace
  var isFixing = false;

  var interval = setInterval(function () {

    var $qtyInput = $('#free-product-qty');
    if (!$qtyInput.length) return;

    var freeQty = parseInt($qtyInput.val(), 10) || 0;

    // ✅ Only act when condition is violated
    if (freeQty <= 1 ) return;

   // isFixing = true;

    $.getJSON('/cart.js')
      .done(function (cart) {

        var freeItems = cart.items.filter(function (item) {
          return item.product_id === FREE_PRODUCT_ID;
        });

        if (!freeItems.length) return;

        var updates = {};
        var first = true;

        $.each(freeItems, function (_, item) {
          updates[item.key] = first ? 1 : 0;
          first = false;
        });

        $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({ updates: updates })
        });

      })
      .always(function () {
        isFixing = false;
        clearInterval(interval); // 🛑 stop once fixed
      });

  }, 1000); // 🔁 every 1 second (cheap DOM read)
});

function checkCartAndAddOrRemoveProduct() {
       $.ajax({
         url: window.location.href,
         type: "GET",
         dataType: "html",
         success: function(data) {
           $('.some_js_items').html($(data).find('.some_js_items').html());
                       $(".header-cart-icon__count").html($(data).find('.header-cart-icon__count').html());

         },
         });
  $("body").removeClass('gidft_removed');

var product_1 = $(".custom_d_1").val();
var product_2 = $(".custom_d_2").val();
var thress_1 = parseInt($(".custom_thres_1").val());
var thress_2 = parseInt($(".custom_thres_2").val());

var check_if_remove = $(".remove_gift_product").val();
var get_product_id =  $(".remove_gift_product").attr('data-id');
  var get_total_price = parseFloat($(".cart-item__price-wrapper").attr('data-price'));
  
            var get_thresold =  parseFloat($("loess-cart-drawer-checkout#CartDrawerTotalPrice").attr('data-left'));
if(check_if_remove == 'yes' || get_total_price <= get_thresold){
  console.log('triggered_click');
    $("tr.free_gift_pdp.cart-item loess-cart-remove-button.remove__button").trigger('click');

}
var add_gift_product = $(".add_gift_product").val();
if(add_gift_product == 'yes'){
if (!localStorage.getItem('gift_unlocked')) {
 
  let checkInterval = setInterval(function() {
  if ($(".free_gift_pdp.cart-item").length > 0) {
    // Add class to body
    $("body").addClass("gift_unlocked");
    localStorage.setItem('gift_unlocked', 'true'); // Save so it doesn't add again


    // Remove after 3s
    setTimeout(function() {
      $("body").removeClass("gift_unlocked");
    }, 1500);

    // Stop further checks
    clearInterval(checkInterval);
  }
}, 500); // checks every 0.5s



  }
  

var check_drawer = $('html').hasClass('scroll-lock');
// if(check_drawer == true){
//   let $drawer = $('.drawer__content');
// let $target = $('#free-gift-offer');

// if ($target.length) {
//   let targetPos = $target.position().top + $drawer.scrollTop();
//   let currentScroll = $drawer.scrollTop();
//   let drawerHeight = $drawer.height();

//   // how far off the scroll is from the target
//   let diff = Math.abs(currentScroll - targetPos);

//   // scroll only if outside "2% threshold"
//   if (diff > drawerHeight * 0.02) {
//     $drawer.animate({ scrollTop: targetPos }, 500);
//   }
// }


// }

}
$("div#free-gift-offer label.card-swatches__button").eq(0).trigger('click');
$("div#free-gift-offer label.card-swatches__button").eq(0).addClass('selected');

    // Check if the products have been added before
    var product1Added = localStorage.getItem(product_1+ 'Added') === 'true';
    var product2Added = localStorage.getItem(product_2+ 'Added') === 'true';
    
    // Get the cart value
    var cartValue = getCartValue();
    
    // If the cart value is less than 400 and product 1 is added, remove product 1
    if (cartValue < thress_1 && product1Added) {
        removeProductFromCart(product_1);
    }
    
    // If the cart value is less than 400 and product 2 is added, remove product 2
    if (cartValue < thress_1 && product2Added) {
        removeProductFromCart(product_2);
    }
    
    // If the cart value is greater than 400 but less than 1000, add product 1 if not already added and remove product 2 if added
    if (cartValue > thress_1 && cartValue < thress_2) {
        if (!product1Added) {
            addProductToCart(product_1);
        }
                 setTimeout(function() {
        if (product2Added) {
            removeProductFromCart(product_2);
        }
                       }, 500);
    }

    // If the cart value is greater than 1000, add product 2 if not already added and remove product 1 if added
    if (cartValue > thress_2) {
      
        if (product1Added) {
            removeProductFromCart(product_1);
        }
         setTimeout(function() {
          if (!product2Added) {
            addProductToCart(product_2);
        }
                            }, 500);

    }
}
window.refreshCartUI = function() {
  $.ajax({
    url: '/',
    type: 'GET',
    dataType: 'html',
    success: function(data) {
      // Update cart drawer content
      $(".drawer__inner.cart-drawer-content").html(
        $(data).find(".drawer__inner.cart-drawer-content").html()
      );

      // Update discount bar
      $(".custom_doscunt_bar").html(
        $(data).find(".custom_doscunt_bar").html()
      );

      // Update other JS-dependent sections
      $(".some_js_items").html(
        $(data).find(".some_js_items").html()
      );

      // Update header cart count
      $(".header-cart-icon__count").html(
        $(data).find(".header-cart-icon__count").html()
      );

      // Reinitialize Slick slider
      $('#FreeShippingText').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: true
      });
    },
    error: function(xhr, status, error) {
      console.error("Error refreshing cart UI:", error);
    }
  });
};
function getCartValue() {
  // Select the cart price element
  var cartValueElement = $('.cart-item__price-wrapper');

  // Check if the element exists
  if (cartValueElement.length === 0) {
    console.warn("Cart value element not found");
    return 0;
  }

  // Get the data-price attribute safely
  var dataPrice = cartValueElement.attr('data-price');

  // Check if data-price is defined and valid
  if (typeof dataPrice === 'undefined' || dataPrice === null || dataPrice === '') {
    console.warn("data-price is undefined or empty");
    return 0;
  }

  // Parse and return the numeric value
  var price = parseFloat(dataPrice);

  // Check if parsing succeeded
  if (isNaN(price)) {
    console.warn("Invalid price value:", dataPrice);
    return 0;
  }

  return price;
}


function addProductToCart(productId) {
                localStorage.setItem(productId + 'Added', 'true');

    // Perform AJAX request to add the product using Shopify AJAX API
    $.ajax({
        url: '/cart/add.js', // URL to Shopify's AJAX endpoint to add product to cart
        method: 'POST',
        data: { 
            quantity: 1, 
            id: productId // Adjust based on the product ID you want to add
        },
        dataType: 'json',
        success: function(response) {
          
new_cart_mini_cart_uppdate();

            // Update the flag in local storage
        },
        error: function(xhr, status, error) {
            console.error(error); // Handle error gracefully
        }
    });
}

function removeProductFromCart(productId) {
    // Perform AJAX request to remove the product using Shopify AJAX API
                localStorage.removeItem(productId + 'Added');

    $.ajax({
        url: '/cart/change.js', // URL to Shopify's AJAX endpoint to change the cart
        method: 'POST',
        data: {
            quantity: 0,
            id: productId // Adjust based on the product ID you want to remove
        },
        dataType: 'json',
        success: function(response) {
new_cart_mini_cart_uppdate();
      $("#free-gift-offer .card-swatches__button[data-available='yes']").eq(0).trigger('click');

            // Remove the flag from local storage
        },
        error: function(xhr, status, error) {
            console.error(error); // Handle error gracefully
        }
    });
}
$(document).ready(function(){
    if (window.location.search.indexOf('view=cart') !== -1) {
    // Run your jQuery script here
    $("div#HeaderCartIcon button").trigger('click');
    
    // Example: your code
    // $('.cart-section').addClass('active');
  }
 $(".featured_col_wrap .tab-link").click(function(){
$(".featured_col_wrap .tab-link").removeClass('current');
    $(this).addClass('current');
    var get_handle = $(this).attr('data-tab');
    console.log(get_handle);
    $(".featured_col_wrap .tab-content").removeClass('current');
    $(".featured_col_wrap .tab-content[data-handle="+get_handle+"]").addClass('current');
    
});
// Call the function on page load
    checkCartAndAddOrRemoveProduct();

// var live_url = window.location.href;
// var result = live_url.includes('form_type=customer');
// var get_c = $("input#FooterNewsletterForm--sections--17148868591840__footer").val().length;

// if(result == true && get_c != 0 ){
//     $("small.form-message.small-text").hide();
//    $(".custom_text_message").show();
// } 
  $('.footer-block-menu div').click(function() {
    // $(this).slideDown(500);
    $(this).toggleClass('selected');
  
 
    $(this).parents('.footer-block-menu').find('.footer-menu__panel').slideToggle();

   
  });
      $('#FreeShippingText').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: true
      });
});  
 // $(document).on("click",".media_alt_custom .card-swatches__button",function() {
 //                var get_link = $(".product_link").val();
 //                var get_id = $(this).attr('data-id');
 //                    var variant_link = get_link + "?variant="+get_id+"&view=alternate";
 //            $.ajax({
 //            url: variant_link ,
 //            type: "GET",
 //            dataType: "html",
 //            success: function(data) {
 //              $('.shopify-section--main-product').html($(data).find('.shopify-section--main-product').html());

 //            },


 //          });
 //    });


// function custom_offers() {
//     // $('.zecpe-btn[name="checkout"]').addClass('custom-stop-event');
//     jQuery.ajax({
//         type: "GET",
//         url: "/cart",
//         dataType: "json",
//         success: function (cart) {

//             var get_all_sub_total = cart.items_subtotal_price / 100;
//             var get_min_price = parseInt($(".min-price-val-ccc").val());
//             var get_max_price = parseInt($(".max-price-val-ccc").val());
//             var get_min_price_id = parseInt($(".min-price-val-ccc").data("id"));
//             var get_max_price_id = parseInt($(".max-price-val-ccc").data("id"));
//             var all_ids = [];
//             var get_added_free_product_price = 0;  
//             $.each(cart.items, function (index, value) {
//                if(value.id == get_min_price_id){
//                      get_added_free_product_price = value.final_line_price  / 100; 
//                 }else if(value.id == get_max_price_id){
//                     get_added_free_product_price = value.final_line_price  / 100;
//                 } 
//               all_ids.push(value.id);
//             });
//             var get_cart_total_price = get_all_sub_total - get_added_free_product_price;
//           if(get_min_price == 0){
//            // console.log('test 2');
//             if(get_cart_total_price < get_max_price) {
//               // console.log('test 3');
//               jQuery.ajax({
//                         type: "POST",
//                         url: "/cart/change.js",
//                         data: {
//                             id: get_max_price_id,
//                             quantity: 0,
//                         },
//                       dataType: "json",
//                         success: function (get_max_price_id) {
//                              new_cart_mini_cart_uppdate();
//                         },
//                     });
//             }else{
//               // console.log('test 4');
//                if ($.inArray(get_max_price_id, all_ids) > -1) {
//                     new_cart_mini_cart_uppdate();
//                 } else {
//                  // console.log('test 1');
//                     jQuery.ajax({
//                         type: "POST",
//                         url: "/cart/add.js",
//                         data: {
//                             id: get_max_price_id,
//                             quantity: 1,
//                         },
//                         dataType: "json",
//                         success: function (get_max_price_id) {
//                             new_cart_mini_cart_uppdate();
//                         },
//                     });
//                 }
              
//             }
//           }else{
//             if (get_cart_total_price > get_min_price && get_cart_total_price < get_max_price) {
//                 if ($.inArray(get_max_price_id, all_ids) > -1) {
//                     jQuery.ajax({
//                         type: "POST",
//                         url: "/cart/change.js",
//                         data: {
//                             id: get_max_price_id,
//                             quantity: 0,
//                         },
//                         dataType: "json",
//                         success: function (get_max_price_id) {
//                             if ($.inArray(get_min_price_id, all_ids) > -1) {
//                                 new_cart_mini_cart_uppdate();
//                             } else {
//                                 jQuery.ajax({
//                                     type: "POST",
//                                     url: "/cart/add.js",
//                                     data: {
//                                         id: get_min_price_id,
//                                         quantity: 1,
//                                     },
//                                     dataType: "json",
//                                     success: function (get_min_price_id) {
//                                         new_cart_mini_cart_uppdate();
//                                     },
//                                 });
//                             }
//                         },
//                     });
//                 } else if ($.inArray(get_min_price_id, all_ids) > -1) {

//                     new_cart_mini_cart_uppdate();
//                 } else {
//                     jQuery.ajax({
//                         type: "POST",
//                         url: "/cart/add.js",
//                         data: {
//                             id: get_min_price_id,
//                             quantity: 1,
//                         },
//                         dataType: "json",
//                         success: function (get_min_price_id) {
//                             new_cart_mini_cart_uppdate();
//                         },
//                     });
//                 }
//             } else if (get_cart_total_price > get_max_price) {
//                 if ($.inArray(get_min_price_id, all_ids) > -1) {
//                     // console.log("min id hai");

//                     jQuery.ajax({
//                         type: "POST",
//                         url: "/cart/change.js",
//                         data: {
//                             id: get_min_price_id,
//                             quantity: 0,
//                         },
//                         dataType: "json",
//                         success: function (get_min_price_id) {
//                             if ($.inArray(get_max_price_id, all_ids) > -1) {
//                                 new_cart_mini_cart_uppdate();
//                             } else {
//                                 jQuery.ajax({
//                                     type: "POST",
//                                     url: "/cart/add.js",
//                                     data: {
//                                         id: get_max_price_id,
//                                         quantity: 1,
//                                     },
//                                     dataType: "json",
//                                     success: function (get_max_price_id) {
//                                        new_cart_mini_cart_uppdate();
//                                     },
//                                 });
//                             }
//                         },
//                     });
//                 } else if ($.inArray(get_max_price_id, all_ids) > -1) {
//                     new_cart_mini_cart_uppdate();
//                 } else {
//                     jQuery.ajax({
//                         type: "POST",
//                         url: "/cart/add.js",
//                         data: {
//                             id: get_max_price_id,
//                             quantity: 1,
//                         },
//                         dataType: "json",
//                         success: function (get_max_price_id) {
//                             new_cart_mini_cart_uppdate();
//                         },
//                     });
//                 }
//             } else if (get_cart_total_price < get_min_price) {
//                 if ($.inArray(get_max_price_id, all_ids) > -1) {
//                     jQuery.ajax({
//                         type: "POST",
//                         url: "/cart/change.js",
//                         data: {
//                             id: get_max_price_id,
//                             quantity: 0,
//                         },
//                         dataType: "json",
//                         success: function (get_max_price_id) {
//                             if ($.inArray(get_min_price_id, all_ids) > -1) {
//                                 jQuery.ajax({
//                                     type: "POST",
//                                     url: "/cart/change.js",
//                                     data: {
//                                         id: get_min_price_id,
//                                         quantity: 0,
//                                     },
//                                     dataType: "json",
//                                     success: function (get_min_price_id) {
//                                         new_cart_mini_cart_uppdate();
//                                     },
//                                 });
//                             } else {
//                                 new_cart_mini_cart_uppdate();
//                             }
//                         },
//                     });
//                 } else if ($.inArray(get_min_price_id, all_ids) > -1) {
//                     jQuery.ajax({
//                         type: "POST",
//                         url: "/cart/change.js",
//                         data: {
//                             id: get_min_price_id,
//                             quantity: 0,
//                         },
//                         dataType: "json",
//                         success: function (get_min_price_id) {
//                             new_cart_mini_cart_uppdate();
//                         },
//                     });
//                 }else{
//                     // $('.zecpe-btn[name="checkout"]').removeClass('custom-stop-event');
//                 }
//             }else{
//               // $('.zecpe-btn[name="checkout"]').removeClass('custom-stop-event');
//             }
           
//           }
//         },
//     });
// }
function new_cart_mini_cart_uppdate() {
      jQuery.ajax({
          type: "GET",
          url: "/",
          dataType: "html",
          success: function (cart) {
            
            var html = $(cart).find("loess-cart-drawer-items").html();
            $("loess-cart-drawer-items").html(html);
            $(".custom_doscunt_bar").html($(cart).find(".custom_doscunt_bar").html()); 
           $('.some_js_items').html($(cart).find('.some_js_items').html());


            $(".header-cart-icon__count").html($(cart).find(".header-cart-icon__count").html()); 
 $('#FreeShippingText').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: true
      });
      $("#free-gift-offer .card-swatches__button[data-available='yes']").eq(0).trigger('click');

          }
      });
  }
$( ".input_cus input" ).on( "change", function() {
  $(this).parents('.product-of').find('.offer_ATC').removeAttr('disabled');
} );
$( ".offer_ATC" ).on( "click", function() {
    var variant_iddd = $(this).parents('.product-of').find('.input_cus input:checked').attr('var_id');
    console.log(variant_iddd);
    jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          
          data: {
            id: variant_iddd,
            quantity: 1,
          },
       dataType: "json",
          success: function (cart) {
            console.log('item added');
            // check_gift(cart);
          }
          });
} );

function check_gift(){
    
var get_less_price = parseInt($(".less_product_price").val());
var get_id = parseInt($(".less_product_id").val());
var get_price = parseInt($(".more_product_id").attr('data-price'));

if (typeof get_less_price === "undefined") {
}else{
  
 jQuery.getJSON('/cart.js', function(cart) {
        console.log(cart);
    let items = cart.items;

   var single_exist = 0 ;

    for(var i=0; i < items.length; i++){
      console.log(items[i].product_type);
      if(items[i].id == get_id){
       get_price = items[i].final_price;
        var single_exist = 1;
      }
    }

   if(get_price> 0 && single_exist == 1){
 var total_price = parseInt(cart.total_price);
  total_price = total_price - get_price;
      }else{
    var total_price = parseInt(cart.total_price);

}
     var item_count = parseInt(cart.item_count);
     if(total_price < get_less_price && item_count > 0 ){
      if(single_exist == 0){
         jQuery.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: {
                            id: get_id,
                            quantity: 1,
                        },
                        dataType: "json",
                        success: function (get_max_price_id) {
                      new_cart_mini_cart_uppdate();
                        },
                    });
      }
     }else{
     // alert('removed')

                          jQuery.ajax({
                        type: "POST",
                        url: "/cart/change.js",
                        data: {
                            id: get_id,
                            quantity: 0,
                        },
                        dataType: "json",
                        success: function (get_min_price_id) {
                    new_cart_mini_cart_uppdate();

                        },
                          });
       
     }
   
 });

}

}
function check_gift2(){

    
var get_less_price = parseInt($(".more_product_price").val());
var get_id = parseInt($(".more_product_id").val());
var get_price = parseInt($(".more_product_id").attr('data-price'));

if (typeof get_less_price === "undefined") {
}else{
  
 jQuery.getJSON('/cart.js', function(cart) {
        console.log(cart);
    let items = cart.items;

   var single_exist = 0 ;

    for(var i=0; i < items.length; i++){
      console.log(items[i].product_type);
      if(items[i].id == get_id){
       get_price = items[i].final_price;
        var single_exist = 1;
      }
    }
    if(get_price> 0 && single_exist == 1){
 var total_price = parseInt(cart.total_price);
  total_price = total_price - get_price;
      }else{
    var total_price = parseInt(cart.total_price);

}
     var item_count = parseInt(cart.item_count);
     if(total_price > get_less_price && item_count > 0 ){
     // alert('test')
      if(single_exist == 0){
         jQuery.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: {
                            id: get_id,
                            quantity: 1,
                        },
                        dataType: "json",
                        success: function (get_max_price_id) {
                      new_cart_mini_cart_uppdate();
                        },
                    });
      }
     }else{
//     alert('removed')

                          jQuery.ajax({
                        type: "POST",
                        url: "/cart/change.js",
                        data: {
                            id: get_id,
                            quantity: 0,
                        },
                        dataType: "json",
                        success: function (get_min_price_id) {
                    new_cart_mini_cart_uppdate();

                        },
                          });
       
     }

   // Free product
          
          // var cart_totall = cart.total_price / 100;
          // var prd_firstt = $('.prd_hide').attr('prd_first');
          // var prd_second = $('.prd_hide').attr('prd_secnd');
          
          // var CartItems2 = cart.items;
          // var targetId2 = parseInt(prd_firstt);
          // var targetId3 = parseInt(prd_second);
          
          // var itemFound2 = CartItems2.some(function (item) {
          // return item.id === targetId2;
          // });
          
          // var itemFound3 = CartItems2.some(function (item) {
          // return item.id === targetId3;
          // });
          
          // if (cart_totall >= 999) {
          // console.log('dono')
          // if (!itemFound3) {
          // addToCart(prd_second);
          // }
          // if (!itemFound2) {
          // addToCart(prd_firstt);
          // }
          // } else if (cart_totall > 699 && cart_totall < 999) {
          // if (!itemFound2) {
          // addToCart(prd_firstt);
          // }
          // if (itemFound2 && cart_totall < 999) {
          // removeFromCart(prd_second);
          // }
          // } else if (cart_totall < 699) {
          // if (itemFound2) {
          // removeFromCart(prd_firstt);
          // }
          // if (itemFound3) {
          // removeFromCart(prd_second);
          // }
          // }
          
          // function addToCart(productId) {
          // jQuery.ajax({
          // type: "POST",
          // url: "/cart/add.js",
          // data: {
          //   id: productId,
          //   quantity: 1,
          // },
          // dataType: "json",
          // success: function () {
          //   new_cart_mini_cart_uppdate();
          // },
          // });
          // }
          
          // function removeFromCart(productId) {
          // jQuery.ajax({
          // type: "POST",
          // url: "/cart/change.js",
          // dataType: "json",
          // data: {
          //   id: productId,
          //   quantity: 0,
          // },
          // success: function () {
          //   new_cart_mini_cart_uppdate();
          // },
          // });
          // }

          // Free product

          // offer product
           
          // offer product
   
 });

}

}

// check_gift();
// check_gift2();
    $(document).on("click",".custom_cart_button",function() {
$(this).text('Adding');
var get_id = $(this).attr('data-id');
      jQuery.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: {
                            id: get_id,
                            quantity: 1,
                        },
                        dataType: "json",
                        success: function (get_max_price_id) {
                      new_cart_mini_cart_uppdate();
            setTimeout(function() {

                  var check_price = $(".cart-item__price-wrapper").attr('data-price222');
      console.log('eeeee');
if(check_price < 20000){
 $(".custom_checkout_wrap .shiprocket-headless").addClass('custom_disable_checkout');
}else{
 $(".custom_checkout_wrap .shiprocket-headless").removeClass('custom_disable_checkout');

}
 }, 3500);
                        },
                    });
    
});
    $(document).on("click",".add_to_cart, .only_default_var ",function(e) {
  e.preventDefault();
e.stopPropagation();
var get_id = $(this).attr('data-id');
$(".custom_class_custom_hide_product form.shopify-product-form input[name='id']").val(get_id);
$(".custom_class_custom_hide_product .product-form__submit").trigger('click');

    
});
$(document).ready(function(){
  $('.custom_banner_inner').slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            swipe: true,
        });
});

$(document).on("click", "div#free-gift-offer .add_to_cart", function (e) {
    e.preventDefault(); // block default
    e.stopPropagation(); // block default

    $(this).find('.spinner').removeClass('hide');
var productId =  $("div#free-gift-offer label.card-swatches__button.selected").attr('data-id');
$("body").addClass('gidft_removed');
$("div#free-gift-offer .add_to_cart").css('opacity','0.5');
$("div#free-gift-offer .add_to_cart").css('pointer-events','none');
                    //    $('.frmain_wrapee_gift').hide();
addProductToCart(productId);
});  
$(document).on("click", "loess-cart-remove-button", function () {
  $("div#free-gift-offer .add_to_cart").css('opacity','0.5');
$("div#free-gift-offer .add_to_cart").css('pointer-events','none');

});  

$(document).on("click", "div#HeaderCartIcon", function () {
checkCartAndAddOrRemoveProduct();
  let $drawer = $('.drawer__content');
let $target = $('#free-gift-offer');

// if ($target.length) {
//   let targetPos = $target.position().top + $drawer.scrollTop();
//   let currentScroll = $drawer.scrollTop();
//   let drawerHeight = $drawer.height();

//   // how far off the scroll is from the target
//   let diff = Math.abs(currentScroll - targetPos);

//   // scroll only if outside "2% threshold"
//   if (diff > drawerHeight * 0.02) {
//     $drawer.animate({ scrollTop: targetPos }, 500);
//   }
// }


});

$(document).on("click", "div#free-gift-offer label.card-swatches__button", function (e) {
  e.preventDefault(); // block default
    e.stopPropagation(); // block default

  let $input = $(this).prev("input[type='radio']"); // find related input
  $input.prop("checked", true).trigger("change");
var get_image = $(this).attr('data-image');
var get_available = $(this).attr('data-available');
if(get_available == "no"){
  $(".add_to_cart span").eq(0).text('Soldout');
    $(".add_to_cart").attr('disabled',true);

}else{
  $(".add_to_cart span").eq(0).text('Add for Free');
    $(".add_to_cart").attr('disabled',false);

}

var get_name = $(this).attr('data-name');
$("div#free-gift-offer legend.input__label.input__label--radio").html('Color: '+get_name+'');
$("img.free-gift__image").attr('src',get_image);
  // optional: add selected styling
  $("div#free-gift-offer label.card-swatches__button").removeClass("selected");
  $(this).addClass("selected");
});
